import React, { useState } from 'react'
import { Input, Picker, Space } from 'antd-mobile'
// import { DownOutline } from 'antd-mobile-icons'
import { countryPhoneCode, formatAndValidatePhoneNumber, formatPhoneNumber, internationalPhone } from '../../utils/FormatPhoneNumber/FormatPhoneNumber';
import { DownOutlined } from '@ant-design/icons';


const MobileField = ({ onChange, form, country, setCountry }) => {
    const [visible, setVisible] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState('');

    const triggerValue = (changedValue) => {
        onChange?.(changedValue);
    };

    const onPhoneChange = (val) => {
        const formattedPhone = formatPhoneNumber(val, country)
        setPhoneNumber(formattedPhone);
        const international = internationalPhone(val, country);
        triggerValue(international);
    };

    const onCountryChange = (value) => {
        const country = value[0];
        if (phoneNumber) {
            const { national, international } = formatAndValidatePhoneNumber(phoneNumber, country);
            form.validateFields(["phone"])
            setPhoneNumber(national);
            triggerValue(international);
        }
        setCountry(country);
    };

    return (
        <>
            <Space align='center'>
                <Space align='center' onClick={() => setVisible(true)} style={{ backgroundColor: "#f5f5f5", padding: "0 5px", borderRadius: "5px" }}>
                    <div>{countryPhoneCode.find(item => item.country === country).code}</div>
                    <span style={{ color: '#d0d0d0',fontSize:"14px" }}> <DownOutlined /></span>
                </Space>
                <Input
                    placeholder='Phone Number'
                    onChange={onPhoneChange}
                    value={phoneNumber}
                />
            </Space>
            <Picker
                columns={[countryPhoneCode.map(item => ({ label: `${item.country} (${item.code})`, value: item.country }))]}
                visible={visible}
                onClose={() => setVisible(false)}
                value={[country]}
                onConfirm={onCountryChange}
            />
        </>
    );
};

export default MobileField